
































import {
  computed,
  ComputedRef,
  defineComponent,
  PropType
} from '@vue/composition-api'
import { DashmixSelectItem } from '@movecloser/ui-core'

import { FormFieldAbstract, FormFieldAbstractSetup } from '../Abstract'
import { FormSelectProps } from './Select.contracts'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 */
export const FormSelect = defineComponent({
  name: 'FormSelect',
  extends: FormFieldAbstract,
  props: {
    autocomplete: {
      type: String,
      default: 'off'
    },
    filterBy: {
      type: Function,
      required: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array as PropType<DashmixSelectItem[]>,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    searchable: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],

  setup (props: FormSelectProps, { emit }) {
    const {
      errors,
      displayLabel,
      hasErrors,
      value
    } = FormFieldAbstractSetup(props, emit)

    const classObject: ComputedRef<object> = computed(() => {
      return {
        'is-invalid': hasErrors.value
      }
    })

    return {
      classObject,
      errors,
      displayLabel,
      hasErrors,
      value
    }
  }
})

export default FormSelect
